import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/components/ui/sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import attendaSvg from "/attendasvg.svg";

const Index = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (password.toLowerCase() === 'attenda4nysc') {
      toast.success('Access granted!');
      // Navigate to the appropriate page based on user role
      navigate('/login', { replace: true });
    } else {
      toast.error('Invalid password');
      setPassword('');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Navigation Bar */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
        <div className="flex items-center gap-4">
          <img 
            src={attendaSvg} 
            alt="ATTENDA" 
            className="w-64 h-16 object-contain"
          />
        </div>
        <h1 className="text-1xl font-extrabold text-yellow-600">
          NYSC
        </h1>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          <Card className="shadow-lg">
            <CardHeader className="pb-6">
              <CardTitle className="text-center text-xl">Enter Password to Access Attendance System for NYSC</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  className="w-full h-12 text-lg"
                  required
                />
                <Button 
                  type="submit" 
                  className="w-full h-12 text-lg bg-yellow-600 text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
                  disabled={loading}
                >
                  {loading ? 'Verifying...' : 'Submit'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Index;
